import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { getAnimationCss } from './helpers';
const Wrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Motion__Wrapper",
  componentId: "sc-tewh1n-0"
})(["", ""], getAnimationCss);
/**
 * @public
 */
export function Motion({
  children,
  isAnimatedState,
  variation = 'growCenter'
}) {
  return React.createElement(Wrapper, {
    isAnimatedState: isAnimatedState,
    variation: variation,
    "data-testid": 'motion-wrapper'
  }, children);
}